module.exports = __webpack_public_path__ + "static/media/Canadian_Logo_white.22c74a57.png";